/**
 *
 * v.1.0  10/11/21  Inicial
 **/

import React from 'react'
import PropTypes from 'prop-types';

export const INPUT_FLOTANTE_MONEDA= 'INPUT_FLOTANTE_MONEDA';
export const INPUT_FLOTANTE_PORCENTAJE= 'INPUT_FLOTANTE_PORCENTAJE';

class InputFlotante extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isFocused: false,
            rawValue: parseFloat(props.value),
            editingText: this.floatToStringFlotante(parseFloat(props.value)),
        };
    }

    // Limpia un string con símbolos, puntos, comas, etc. y devuelve un número
    stringMonedaToFloat = (input) => {
        if (!input) return 0;
        // Elimina símbolo €, espacios, y convierte coma a punto
        const cleaned = input
            .replace(/[^0-9,.-]/g, '') // deja solo números, coma, punto y guión
            .replace(/\./g, '')        // elimina puntos de miles
            .replace(',', '.');        // cambia la coma decimal a punto

        const parsed = parseFloat(cleaned);
        return isNaN(parsed) ? 0 : parsed;
    };

    // Convierte valor numérico a string formateado tipo "1.234,56 €"
    floatToStringFlotante = (value) => {
        const {tipo} = this.props;
        console.log("floatToStringMoneda");
        console.log("tipo: ", tipo);
        console.log("value: ", value);

        if (value == null || isNaN(value)) return '';
        const cents = Math.round(value * 100);
        const rawString = cents.toString().padStart(3, '0');
        const intPart = rawString.slice(0, -2);
        const decPart = rawString.slice(-2);
        const intFormatted = parseInt(intPart, 10).toLocaleString('es-ES');
        switch (tipo){
            case INPUT_FLOTANTE_MONEDA:
                return `${intFormatted},${decPart} €`;
                break;

            case INPUT_FLOTANTE_PORCENTAJE:
                return `${intFormatted},${decPart} %`;
                break;
        }
    };


    handleFocus = () => {
        const {rawValue} = this.state;
        const {readOnly} = this.props;
        console.log("handleFocus!");
        console.log("rawValue: ", rawValue);

        if (readOnly && Boolean(readOnly))
            return;

        this.setState({
            isFocused: true,
            editingText: rawValue != null && !isNaN(rawValue) ? rawValue.toString().replace('.', ',') : '',
        });
    };

    handleBlur = () => {
        const {rawValue} = this.state;
        console.log("handleBlur!");

        this.setState({
            isFocused: false,
            editingText: this.floatToStringFlotante(rawValue),
        });
    };


    handleChange = (e) => {
        const {onChange} = this.props;
        const input = e.target.value;
        const newRawValue = this.stringMonedaToFloat(input);
        this.setState({editingText: input, rawValue: newRawValue});
        onChange && onChange(newRawValue);
    };


    render() {
        const {tipo} = this.props;

        let placeholder= "";
        switch (tipo){
            case INPUT_FLOTANTE_MONEDA: placeholder= "0,00 €"; break;
            case INPUT_FLOTANTE_PORCENTAJE: placeholder= "0 %"; break;
        }

        const {rawValue, editingText, className} = this.state;
        return (
            <input
                type="text"
                //value={displayValue}
                value={editingText}
                placeholder= {placeholder}
                onFocus={this.handleFocus}
                onBlur={this.handleBlur}
                onChange={this.handleChange}
                className= {className}
            />
        );
    }

}


InputFlotante.propTypes = {
    className: PropTypes.string,
    value: PropTypes.number,
    onChange: PropTypes.func,
    tipo: PropTypes.string,
}

export default InputFlotante